import { useTranslation } from "react-i18next"
import { TaxContribution } from "@oysterhr/schema"
import classNames from "classnames"
import { QuoteEmploymentCardProps } from "../../types"
import { getAmountWithCurrencyAndCommas } from "../../utils/helpers"
import { QuoteCard } from "../QuoteCard"
import { QuoteCollapsableItem } from "../QuoteCollapsableItem"
import { QuoteItem } from "../QuoteItem"
import { IconWithTooltip } from "@oysterhr/feature-components"

export function QuoteEmployeeCard({
  annualGrossSalary,
  calculation,
  cycle,
}: QuoteEmploymentCardProps) {
  const { t } = useTranslation("components/Quote")
  const totalEmployeeTaxes = calculation.taxes.employee.total
  const employeeTaxes: TaxContribution[] = calculation.taxes.employee.contributions

  return (
    <QuoteCard
      className={classNames("w-full last:mr-0 md:mr-4 lg:pl-2")}
      title={t("titleCardEmployee")}
      items={[
        <QuoteItem
          key="grossSalary"
          isCategory
          value={getAmountWithCurrencyAndCommas(
            Number(annualGrossSalary),
            calculation.currency.code,
            cycle,
          )}
          label={t("labelGrossSalary", { cycle })}
        />,
        <QuoteCollapsableItem
          key="estimated"
          isCategory
          isDeductable
          value={getAmountWithCurrencyAndCommas(
            Number(totalEmployeeTaxes),
            calculation.currency.code,
            cycle,
          )}
          label={
            <div>
              {t("labelEstimatedTaxesSecurity")}
              <IconWithTooltip
                value={t("tooltipEmployeeCosts")}
                className="ml-0.5"
                icon="InfoCircle"
                size="xs"
              />
            </div>
          }
          items={employeeTaxes.map(tax => (
            <QuoteItem
              className="mb-0 text-gray-400"
              key={tax.name}
              label={tax.name}
              value={getAmountWithCurrencyAndCommas(tax.amount, calculation.currency.code, cycle)}
            />
          ))}
        />,
        <QuoteItem
          key="netSalary"
          value={getAmountWithCurrencyAndCommas(
            calculation.totals.netSalary,
            calculation.currency.code,
            cycle,
          )}
          label={
            <div>
              {t("netCycleSalary", { cycle })}
              <IconWithTooltip
                className="ml-0.5"
                icon="InfoCircle"
                value={t("tooltipNetMonthlySalary")}
                size="xs"
              />
            </div>
          }
          bold
          className="mb-0"
        />,
      ]}
    />
  )
}
